export enum IdentificationSteps {
  START,
  DOCUMENT,
  SELFIE,
  OVERVIEW
}
